// extracted by mini-css-extract-plugin
module.exports = {"badge":"_1-AvTNvenxuS9s3YLnck_-","badgeMarvelLogo":"_2qe1E0ur70-sFBVWGIfYXk"};